import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeColors from '../assets/styles/themeColors';

import { ParagraphNormal } from './Paragraph';

const InfoContainer = styled.div`
  display: flex;
  margin-top: 48px;
  padding-left: 15px;
  border-left: 1px solid ${themeColors.colorTextSecondary};
`;
const HighlightText = styled.span`
  font-weight: 600;
`;

const AdditionalInfo = ({ highlight, info }) => (
  <InfoContainer>
    <ParagraphNormal>
      <HighlightText>{highlight}</HighlightText> {info}
    </ParagraphNormal>
  </InfoContainer>
);

AdditionalInfo.propTypes = {
  highlight: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
};

export default AdditionalInfo;
